import { useState } from "react";
import beyondtax from "../../images/beyondtax.png";

const MergedIcon = () => (
  <svg aria-hidden="true" height="16" viewBox="0 0 16 16" width="16" style={{ fill: "var(--gh-purple)" }}>
    <path d="M5.45 5.154A4.25 4.25 0 0 0 9.25 7.5h1.378a2.251 2.251 0 1 1 0 1.5H9.25A5.734 5.734 0 0 1 5 7.123v3.505a2.25 2.25 0 1 1-1.5 0V5.372a2.25 2.25 0 1 1 1.95-.218ZM4.25 13.5a.75.75 0 1 0 0-1.5.75.75 0 0 0 0 1.5Zm8.5-4.5a.75.75 0 1 0 0-1.5.75.75 0 0 0 0 1.5ZM5 3.25a.75.75 0 1 0 0 .005V3.25Z" />
  </svg>
);

const OpenIcon = () => (
  <svg aria-hidden="true" height="16" viewBox="0 0 16 16" width="16" style={{ fill: "var(--gh-green)" }}>
    <path d="M1.5 3.25a2.25 2.25 0 1 1 3 2.122v5.256a2.251 2.251 0 1 1-1.5 0V5.372A2.25 2.25 0 0 1 1.5 3.25Zm5.677-.177L9.573.677A.25.25 0 0 1 10 .854V2.5h1A2.5 2.5 0 0 1 13.5 5v5.628a2.251 2.251 0 1 1-1.5 0V5a1 1 0 0 0-1-1h-1v1.646a.25.25 0 0 1-.427.177L7.177 3.427a.25.25 0 0 1 0-.354ZM3.75 2.5a.75.75 0 1 0 0 1.5.75.75 0 0 0 0-1.5Zm0 9.5a.75.75 0 1 0 0 1.5.75.75 0 0 0 0-1.5Zm8.25.75a.75.75 0 1 0 1.5 0 .75.75 0 0 0-1.5 0Z" />
  </svg>
);

const experiences = [
  {
    id: 1,
    prNumber: "#3",
    title: "Frontend Developer (React.js)",
    company: "Beyondtax",
    companyLink: "https://beyondtax.co/",
    location: "Aiyug Beyondtax Private Limited",
    duration: "June 2024 – Present",
    type: "Full-time",
    status: "open",
    description: [
      "Built a reusable component library that cut new-feature development time by 30%, helping the team ship faster without accumulating UI debt",
      "Developed core fintech modules from scratch, including GSTR compliance flows, tax invoices, credit/debit notes, and an in-browser PDF viewer live in production",
      "Integrated 200+ REST APIs with cookie-based authentication and AbortController patterns, eliminating race conditions and memory leaks on route transitions",
      "Shipped a real-time chat feature with WebSockets and a Word-like document template engine with dynamic field injection and PDF export",
      "Led code reviews for 3 interns and owned sprint estimation, maintaining 90%+ on-time delivery across consecutive quarters",
    ],
    technologies: ["React.js", "JavaScript", "REST APIs", "WebSockets", "PDF Export", "Tailwind CSS", "Git"],
    logo: beyondtax,
    branch: "feat/frontend-developer",
  },
  {
    id: 2,
    prNumber: "#2",
    title: "Frontend Developer (React.js)",
    company: "CoziQ",
    companyLink: null,
    location: "CoziQ Experiences – Private Dining Startup",
    duration: "February 2024 – April 2024",
    type: "Internship",
    status: "merged",
    description: [
      "Delivered pixel-perfect UI components from Figma specs with zero revision requests from the design team at sign-off",
      "Resolved the platform's top-reported UX lag by refactoring async state and API handling on the bookings flow",
    ],
    technologies: ["React.js", "JavaScript", "Figma", "REST APIs", "CSS"],
    logo: null,
    branch: "feat/coziq-internship",
  },
  {
    id: 3,
    prNumber: "#1",
    title: "General Secretary",
    company: "Ordinateur",
    companyLink: null,
    location: "The Computer Science Society of Hansraj College",
    duration: "October 2022 – October 2023",
    type: "Leadership",
    status: "merged",
    description: [
      "Managed and coordinated a team of 100+ members smoothly and professionally",
      "Coordinated with Team Heads and Teacher coordinators for smooth society event flow",
      "Led and managed technical and non-technical events for the CS society",
      "Organised technical workshops and coding competitions for students",
    ],
    technologies: ["Leadership", "Event Management", "Team Coordination", "Public Speaking"],
    logo: null,
    branch: "feat/general-secretary",
  },
];

const statusConfig = {
  open:   { icon: <OpenIcon />,   bg: "rgba(63,185,80,0.15)",   color: "var(--gh-green)", border: "rgba(63,185,80,0.4)" },
  merged: { icon: <MergedIcon />, bg: "rgba(163,113,247,0.15)", color: "var(--gh-purple)", border: "rgba(163,113,247,0.4)" },
};

const Experience = () => {
  const [active, setActive] = useState(0);
  // "all" | "open" | "merged"
  const [filter, setFilter] = useState("all");

  const openCount   = experiences.filter(e => e.status === "open").length;
  const mergedCount = experiences.filter(e => e.status === "merged").length;

  const filtered = filter === "all"
    ? experiences
    : experiences.filter(e => e.status === filter);

  // Reset active index when filter changes; pick first visible item
  const handleFilter = (f) => {
    setFilter(f);
    const list = f === "all" ? experiences : experiences.filter(e => e.status === f);
    // pick index of first item in list within original array
    const idx = experiences.findIndex(e => e.id === list[0]?.id);
    setActive(idx >= 0 ? idx : 0);
  };

  const exp = experiences[active];
  const st  = statusConfig[exp.status];

  // Merged text differs from open
  const isMerged = exp.status === "merged";

  return (
    <div>
      {/* Page header */}
      <div style={{ marginBottom: 20 }}>
        <h2 style={{ fontSize: 20, fontWeight: 600, color: "var(--gh-text)", marginBottom: 4 }}>Pull Requests</h2>
        <p style={{ fontSize: 14, color: "var(--gh-text-secondary)" }}>
          My professional journey — current role is Open, completed roles are Merged.
        </p>
      </div>

      {/* Filter tabs */}
      <div style={{ display: "flex", gap: 4, marginBottom: 16, borderBottom: "1px solid var(--gh-border)", paddingBottom: 0 }}>
        {[
          { key: "all",    label: "All",    count: experiences.length },
          { key: "open",   label: "Open",   count: openCount,   icon: <OpenIcon /> },
          { key: "merged", label: "Merged", count: mergedCount, icon: <MergedIcon /> },
        ].map(tab => (
          <button
            key={tab.key}
            onClick={() => handleFilter(tab.key)}
            style={{
              display: "flex", alignItems: "center", gap: 6,
              padding: "8px 12px", fontSize: 14, cursor: "pointer",
              background: "transparent", border: "none",
              color: filter === tab.key ? "var(--gh-text)" : "var(--gh-text-secondary)",
              fontWeight: filter === tab.key ? 600 : 400,
              borderBottom: filter === tab.key ? "2px solid var(--gh-accent)" : "2px solid transparent",
              marginBottom: -1,
              transition: "color 0.15s",
            }}
          >
            {tab.icon && tab.icon}
            {tab.label}
            <span style={{
              background: "rgba(110,118,129,0.2)", borderRadius: "2em",
              padding: "0 6px", fontSize: 12, color: "var(--gh-text-secondary)",
            }}>
              {tab.count}
            </span>
          </button>
        ))}
      </div>

      {/* Split layout */}
      <div className="exp-split" style={{ display: "flex", gap: 16, alignItems: "flex-start" }}>

        {/* PR List */}
        <div className="exp-list" style={{ width: 260, flexShrink: 0 }}>
          {filtered.length === 0 ? (
            <p style={{ color: "var(--gh-text-secondary)", fontSize: 13, padding: 12 }}>No items match this filter.</p>
          ) : (
            filtered.map((e) => {
              const s = statusConfig[e.status];
              const isActive = active === experiences.findIndex(x => x.id === e.id);
              const origIdx = experiences.findIndex(x => x.id === e.id);
              return (
                <div
                  key={e.id}
                  onClick={() => setActive(origIdx)}
                  style={{
                    padding: "12px 14px", borderRadius: 6, marginBottom: 4,
                    cursor: "pointer",
                    background: isActive ? "var(--gh-card)" : "transparent",
                    border: `1px solid ${isActive ? "var(--gh-link)" : "var(--gh-border)"}`,
                    transition: "all 0.15s",
                  }}
                >
                  <div style={{ display: "flex", alignItems: "center", gap: 8, marginBottom: 4 }}>
                    {s.icon}
                    <span style={{ fontSize: 12, color: "var(--gh-text-secondary)" }}>{e.prNumber}</span>
                  </div>
                  <div style={{ fontSize: 13, fontWeight: 600, color: isActive ? "var(--gh-link)" : "var(--gh-text)", marginBottom: 2 }}>
                    {e.title}
                  </div>
                  <div style={{ fontSize: 12, color: "var(--gh-text-secondary)" }}>{e.company}</div>
                  <div style={{ fontSize: 11, color: "var(--gh-text-muted)", marginTop: 4 }}>{e.duration}</div>
                </div>
              );
            })
          )}
        </div>

        {/* PR Detail */}
        <div style={{ flex: 1, minWidth: 0 }}>
          {/* PR title */}
          <div style={{ marginBottom: 16 }}>
            <h3 style={{ fontSize: 22, fontWeight: 600, color: "var(--gh-text)", marginBottom: 10 }}>
              {exp.title}{" "}
              <span style={{ color: "var(--gh-text-secondary)", fontWeight: 400 }}>{exp.prNumber}</span>
            </h3>

            {/* Status badge + branch info */}
            <div style={{ display: "flex", alignItems: "center", gap: 10, flexWrap: "wrap" }}>
              <span style={{
                display: "inline-flex", alignItems: "center", gap: 6,
                padding: "4px 12px", borderRadius: 2000,
                background: st.bg, color: st.color,
                border: `1px solid ${st.border}`,
                fontSize: 13, fontWeight: 600,
              }}>
                {st.icon}
                {isMerged ? "Merged" : "Open"}
              </span>

              {isMerged ? (
                <span style={{ fontSize: 13, color: "var(--gh-text-secondary)" }}>
                  <strong style={{ color: "var(--gh-purple)" }}>akanshaBharti</strong> merged{" "}
                  <code style={{ background: "var(--gh-card)", padding: "1px 6px", borderRadius: 4, fontSize: 12, color: "var(--gh-purple)", border: "1px solid var(--gh-border)" }}>
                    {exp.branch}
                  </code>
                  {" "}into{" "}
                  <code style={{ background: "var(--gh-card)", padding: "1px 6px", borderRadius: 4, fontSize: 12, color: "var(--gh-link)", border: "1px solid var(--gh-border)" }}>
                    main
                  </code>
                </span>
              ) : (
                <span style={{ fontSize: 13, color: "var(--gh-text-secondary)" }}>
                  <strong style={{ color: "var(--gh-link)" }}>akanshaBharti</strong> opened from{" "}
                  <code style={{ background: "var(--gh-card)", padding: "1px 6px", borderRadius: 4, fontSize: 12, color: "var(--gh-link)", border: "1px solid var(--gh-border)" }}>
                    {exp.branch}
                  </code>
                  {" "}into{" "}
                  <code style={{ background: "var(--gh-card)", padding: "1px 6px", borderRadius: 4, fontSize: 12, color: "var(--gh-link)", border: "1px solid var(--gh-border)" }}>
                    main
                  </code>
                </span>
              )}
            </div>
          </div>

          {/* Conversation tab header */}
          <div style={{ borderBottom: "1px solid var(--gh-border)", marginBottom: 16 }}>
            <div style={{ display: "flex" }}>
              <div style={{
                padding: "8px 16px", fontSize: 13, color: "var(--gh-text)",
                borderBottom: "2px solid var(--gh-accent)", fontWeight: 600, marginBottom: -1,
              }}>
                Conversation
              </div>
            </div>
          </div>

          {/* Comment body */}
          <div style={{ display: "flex", gap: 12 }}>
            <div style={{
              width: 40, height: 40, borderRadius: "50%",
              background: "linear-gradient(135deg, var(--gh-green-btn), #1f6feb)",
              display: "flex", alignItems: "center", justifyContent: "center",
              fontSize: 14, fontWeight: 700, color: "white", flexShrink: 0,
            }}>
              AB
            </div>

            <div style={{ flex: 1, background: "var(--gh-surface)", border: "1px solid var(--gh-border)", borderRadius: 6, overflow: "hidden" }}>
              {/* Comment header */}
              <div style={{
                padding: "10px 16px", background: "var(--gh-card)",
                borderBottom: "1px solid var(--gh-border)",
                display: "flex", alignItems: "center", justifyContent: "space-between",
              }}>
                <span style={{ fontSize: 13, color: "var(--gh-text-secondary)" }}>
                  <strong style={{ color: "var(--gh-link)" }}>akanshaBharti</strong>
                  {" "}{isMerged ? "contributed at" : "is working at"}{" "}
                  <strong style={{ color: "var(--gh-text)" }}>{exp.company}</strong>
                  {" · "}{exp.duration}
                </span>
                <span style={{
                  padding: "2px 8px", borderRadius: 4, fontSize: 11, fontWeight: 500,
                  background: exp.type === "Full-time" ? "rgba(63,185,80,0.15)"
                    : exp.type === "Internship" ? "var(--gh-link-shadow)"
                    : "rgba(227,179,65,0.15)",
                  color: exp.type === "Full-time" ? "var(--gh-green)"
                    : exp.type === "Internship" ? "var(--gh-link)"
                    : "var(--gh-yellow)",
                  border: `1px solid ${exp.type === "Full-time" ? "rgba(63,185,80,0.4)"
                    : exp.type === "Internship" ? "rgba(88,166,255,0.4)"
                    : "rgba(227,179,65,0.4)"}`,
                }}>
                  {exp.type}
                </span>
              </div>

              {/* Comment content */}
              <div style={{ padding: 16 }}>
                {/* Company badge */}
                <div style={{
                  display: "flex", alignItems: "center", gap: 10, marginBottom: 14,
                  padding: 12, background: "var(--gh-card)", borderRadius: 6, border: "1px solid var(--gh-border)",
                }}>
                  {exp.logo
                    ? <img src={exp.logo} alt={exp.company} style={{ width: 32, height: 32, borderRadius: 4, objectFit: "contain" }} />
                    : <div style={{ width: 32, height: 32, borderRadius: 4, background: "var(--gh-border)", display: "flex", alignItems: "center", justifyContent: "center", fontSize: 13, fontWeight: 700, color: "var(--gh-text-secondary)" }}>{exp.company[0]}</div>
                  }
                  <div>
                    {exp.companyLink
                      ? <a href={exp.companyLink} target="_blank" rel="noopener noreferrer" style={{ color: "var(--gh-link)", fontWeight: 600, textDecoration: "none", fontSize: 15 }}>{exp.company} ↗</a>
                      : <span style={{ color: "var(--gh-text)", fontWeight: 600, fontSize: 15 }}>{exp.company}</span>
                    }
                    <p style={{ fontSize: 12, color: "var(--gh-text-secondary)", margin: "2px 0 0" }}>{exp.location}</p>
                  </div>
                </div>

                {/* Responsibilities */}
                <h4 style={{ fontSize: 12, fontWeight: 600, color: "var(--gh-text-secondary)", marginBottom: 10, textTransform: "uppercase", letterSpacing: "0.05em" }}>
                  {isMerged ? "Contributions" : "Current responsibilities"}
                </h4>
                <ul style={{ paddingLeft: 0, listStyle: "none", marginBottom: 14 }}>
                  {exp.description.map((item, i) => (
                    <li key={i} style={{ display: "flex", alignItems: "flex-start", gap: 8, marginBottom: 8 }}>
                      <span style={{ color: isMerged ? "var(--gh-purple)" : "var(--gh-green)", marginTop: 2, flexShrink: 0 }}>
                        {isMerged ? "✓" : "+"}
                      </span>
                      <span style={{ fontSize: 14, color: "var(--gh-text)", lineHeight: 1.5 }}>{item}</span>
                    </li>
                  ))}
                </ul>

                {/* Tech stack */}
                <div style={{ borderTop: "1px solid var(--gh-border)", paddingTop: 12 }}>
                  <h4 style={{ fontSize: 12, fontWeight: 600, color: "var(--gh-text-secondary)", marginBottom: 8, textTransform: "uppercase", letterSpacing: "0.05em" }}>
                    Technologies
                  </h4>
                  <div style={{ display: "flex", flexWrap: "wrap", gap: 6 }}>
                    {exp.technologies.map(tech => (
                      <span key={tech} className="gh-topic">{tech}</span>
                    ))}
                  </div>
                </div>
              </div>
            </div>
          </div>

          {/* Status bar */}
          <div style={{
            marginTop: 16, padding: "12px 16px", borderRadius: 6,
            border: `1px solid ${st.border}`,
            background: isMerged ? "rgba(163,113,247,0.08)" : "rgba(63,185,80,0.08)",
            display: "flex", alignItems: "center", gap: 10,
          }}>
            {st.icon}
            <span style={{ fontSize: 14, color: st.color, fontWeight: 600 }}>
              {isMerged
                ? `Merged — ${exp.duration}`
                : `Open · Currently active — ${exp.duration}`}
            </span>
          </div>
        </div>
      </div>
      <style>{`
        @media (max-width: 640px) {
          .exp-split { flex-direction: column !important; }
          .exp-list { width: 100% !important; }
        }
      `}</style>
    </div>
  );
};

export default Experience;
